/**
 * VITB Lightbox — Video / Imagen ampliados con sonido
 */
(function () {
  'use strict';

  function toEmbedUrl(url) {
    if (!url) return null;
    let m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([A-Za-z0-9_-]{11})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1';
    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return null;
  }

  function initSection(section) {
    const lb      = section.querySelector('[data-vitb-lightbox]');
    if (!lb) return;
    const content = lb.querySelector('[data-vitb-lb-content]');
    const kind    = lb.dataset.lbKind;
    const imgSrc  = lb.dataset.lbImageSrc;
    const imgAlt  = lb.dataset.lbImageAlt;
    const videoUrl = lb.dataset.lbVideoUrl;

    let lastFocus = null;

    function stopMedia() {
      content.querySelectorAll('video').forEach(v => { v.pause(); v.src = ''; });
      content.querySelectorAll('iframe').forEach(f => { f.src = ''; });
    }

    function open() {
      lastFocus = document.activeElement;
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      content.innerHTML = '<div class="vitb-lb__spinner"></div>';
      render();
      document.addEventListener('keydown', onKey);
      requestAnimationFrame(() => lb.querySelector('.vitb-lb__close')?.focus());
    }

    function close() {
      stopMedia();
      lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      content.innerHTML = '<div class="vitb-lb__spinner"></div>';
      lastFocus?.focus();
    }

    function render() {
      content.innerHTML = '';

      if (kind === 'image' && imgSrc) {
        const img = new Image();
        img.className = 'vitb-lb__img';
        img.alt = imgAlt || '';
        img.onload = () => { content.innerHTML = ''; content.appendChild(img); };
        img.onerror = () => { content.innerHTML = '<p style="color:#fff;font-size:14px;text-align:center;">No se pudo cargar la imagen.</p>'; };
        img.src = imgSrc;

      } else if (kind === 'video_file') {
        // Video nativo con sonido (sin muted)
        const sources = section.querySelectorAll('[data-vitb-lb-src]');
        if (sources.length) {
          const video = document.createElement('video');
          video.className = 'vitb-lb__video';
          video.controls = true;
          video.autoplay = true;
          video.playsinline = true;
          video.loop = false;
          sources.forEach(s => {
            const src = document.createElement('source');
            src.src  = s.dataset.vitbLbSrc;
            src.type = s.dataset.vitbLbType;
            video.appendChild(src);
          });
          content.appendChild(video);
        }

      } else if (kind === 'video_url') {
        const embedUrl = toEmbedUrl(videoUrl) || videoUrl;
        if (embedUrl) {
          const wrap = document.createElement('div');
          wrap.className = 'vitb-lb__iframe-wrap';
          const iframe = document.createElement('iframe');
          iframe.src = embedUrl;
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.title = 'Video DIBAI';
          wrap.appendChild(iframe);
          content.appendChild(wrap);
        }
      }
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    // Abrir al hacer clic en el trigger
    section.querySelectorAll('[data-vitb-lb-open]').forEach(btn => {
      btn.addEventListener('click', open);
    });

    // Cerrar
    lb.querySelectorAll('[data-vitb-lb-close]').forEach(el => {
      el.addEventListener('click', close);
    });
  }

  function init() {
    document.querySelectorAll('.vitb-dibai-wrapper').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', e => {
    const w = e.target.querySelector?.('.vitb-dibai-wrapper');
    if (w) initSection(w);
  });
})();
